import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Select, Button, Space, Typography } from "antd";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { getThisWeeksFriday } from "../../utils/formatters";

const { Text } = Typography;

const PRESET_OPTIONS = [
  { value: "1month", label: "1 Month", weeks: 4 },
  { value: "2months", label: "2 Months", weeks: 8 },
  { value: "3months", label: "3 Months", weeks: 12 },
  { value: "4months", label: "4 Months", weeks: 16 },
];

const TimeframeSelector = ({ onDateRangeChange = () => {} }) => {
  const [preset, setPreset] = useState("1month");
  const [offset, setOffset] = useState(0);

  const friday = useMemo(() => getThisWeeksFriday(), []);

  const presetWeeks = useMemo(() => {
    return PRESET_OPTIONS.find((o) => o.value === preset)?.weeks ?? 4;
  }, [preset]);

  const { startDate, endDate } = useMemo(() => {
    const end = friday.subtract(offset * presetWeeks, "week");
    const start = end.subtract(presetWeeks, "week").add(1, "day");
    return {
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    };
  }, [friday, offset, presetWeeks]);

  useEffect(() => {
    onDateRangeChange(startDate, endDate);
  }, [startDate, endDate, onDateRangeChange]);

  const canGoNext = offset > 0;

  const handlePresetChange = useCallback((value) => {
    setPreset(value);
    setOffset(0);
  }, []);

  const handlePrev = useCallback(() => {
    setOffset((o) => o + 1);
  }, []);

  const handleNext = useCallback(() => {
    setOffset((o) => Math.max(0, o - 1));
  }, []);

  const formatDisplayDate = (dateStr) => dayjs(dateStr).format("MMM DD, YYYY");

  return (
    <Space size="middle" wrap align="center">
      <CalendarOutlined style={{ color: "#1890ff", fontSize: 16 }} />
      <Text strong>Timeframe:</Text>
      <Select
        value={preset}
        // size="small"
        onChange={handlePresetChange}
        options={PRESET_OPTIONS}
        style={{ minWidth: 140 }}
      />
      <Button
        // size="small"
        icon={<ArrowLeftOutlined />}
        onClick={handlePrev}
        title="Previous period"
      ></Button>
      <Text
        strong
        style={{
          minWidth: 210,
          textAlign: "center",
          display: "inline-block",
          fontSize: 14,
        }}
      >
        {formatDisplayDate(startDate)} — {formatDisplayDate(endDate)}
      </Text>
      <Button
        // size="small"
        icon={<ArrowRightOutlined />}
        iconPlacement="end"
        onClick={handleNext}
        disabled={!canGoNext}
        title="Next period"
      ></Button>
    </Space>
  );
};

export default TimeframeSelector;
